import { api } from './base';

import { MutationArg } from 'v2/types';
import { EntryRewardModel } from 'v2/types/RewardModel';
import { SWRKeyValue } from 'v2/types/swr';

export const entryRewardService = {
  getEntryRewards(): Promise<EntryRewardModel[]> {
    return api.get('v1/admin/entry-rewards').json();
  },

  createEntryReward(
    _key: string,
    { arg }: MutationArg<Omit<EntryRewardModel, 'id' | 'status'>>
  ): Promise<EntryRewardModel> {
    return api.post('v1/admin/entry-rewards', { json: arg }).json();
  },

  updateEntryReward(
    [_key, rewardId]: SWRKeyValue,
    { arg }: MutationArg<Omit<EntryRewardModel, 'id' | 'status'>>
  ): Promise<EntryRewardModel> {
    return api.put(`v1/admin/entry-rewards/${rewardId}`, { json: arg }).json();
  },

  deleteEntryReward([_key, rewardId]: SWRKeyValue): Promise<void> {
    return api.delete(`v1/admin/entry-rewards/${rewardId}`).json();
  },
};
